import { Injectable, inject } from '@angular/core';
import { Actions,createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GraphQlService } from '@shared/services/graphql-service';
import { ApolloNamespace } from '@shared/enums/apollo-namespaces';
import { GET_WORKFLOW_INSTANCE_BY_BUSINESS_KEY, GET_WORKFLOW_STATUS_BY_BUSINESS_KEY } from '../workflow-client.graphql';
import { WorkflowInstanceResponse } from '../responses/workflow-instance.response';
import { WorkflowStatusResponse } from '../responses/workflow-status.response';
import * as WorkflowActions from './workflow.actions';

@Injectable()
export class WorkflowEffects {
    private actions$ = inject(Actions);
    private graphqlService = inject(GraphQlService);

    loadWorkflowInstance$ = createEffect(() => this.actions$.pipe(
        ofType(WorkflowActions.loadWorkflowInstance),
        switchMap(({ businessKey }) =>
            this.graphqlService.query<WorkflowInstanceResponse>({
                query: GET_WORKFLOW_INSTANCE_BY_BUSINESS_KEY,
                variables: { businessKey },
                apolloNamespace: ApolloNamespace.workflow
            }).pipe(
                map(response => WorkflowActions.loadWorkflowInstanceSuccess({
                    workflowInstance: response.data.workflowInstanceByBusinessKey
                })),
                catchError(error => of(WorkflowActions.loadWorkflowInstanceFailure({ error })))
            )
        )
    ));

    loadWorkflowStatus$ = createEffect(() => this.actions$.pipe(
        ofType(WorkflowActions.loadWorkflowStatus),
        switchMap(({ businessKey, businessType }) =>
            this.graphqlService.query<WorkflowStatusResponse>({
                query: GET_WORKFLOW_STATUS_BY_BUSINESS_KEY,
                variables: { businessKey, businessType },
                apolloNamespace: ApolloNamespace.workflow
            }).pipe(
                map(response => WorkflowActions.loadWorkflowStatusSuccess({
                    workflowStatus: response.data.workflowStatusByBusinessKey
                })),
                catchError(error => of(WorkflowActions.loadWorkflowStatusFailure({ error })))
            )
        )
    ));
}
